import React, { useContext, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as Logo } from '../../../../../../assets/icons/v3/betterfly-logo-white.svg';
import BdsIconButton from '../../../../../../shared/components/v3/Buttons/BdsIconButton/BdsIconButton';
import { THUMBS_DOWN_ICON, THUMBS_UP_ICON } from '../../../../../../shared/constants/images';
import { CLICK_ACTION, THUMBS_DOWN, THUMBS_UP } from '../../../../../../shared/constants/tagManager';
import { CompanyContext } from '../../../../../../shared/context/company/companyContext';
import { IHealthReportList } from '../../../../../../shared/interfaces/reports';
import TagManagerService from '../../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import { formatDateForDisplay } from '../../../../../../shared/utils/datetime/datetime';
import './HealthReportFooter.scss';

export const HealthReportFooter = ({ reportList }: { reportList: IHealthReportList }) => {
  const [disabled, setDisabled] = useState(false);
  const [selectedType, setSelectedType] = useState<string>('');
  const { t } = useTranslation();

  const { isUSA } = useContext(CompanyContext);

  const onFeedback = (tag: typeof THUMBS_UP | typeof THUMBS_DOWN) => {
    TagManagerService.pushEvent(CLICK_ACTION, tag);
    setDisabled(true);
    setSelectedType(tag);
    setTimeout(() => setDisabled(false), 10000);
  };

  return (
    <div className="health-report-footer">
      <div className="health-report-top-bar">
        <Logo className="report-logo" />
        <div className="generation-date">
          {t(TRANSLATIONS_REPORTS.healthReport.footer.generatedDate, {
            date: formatDateForDisplay(reportList.endDate, isUSA),
            interpolation: { escapeValue: false }
          })}
        </div>
      </div>
      <div className="report-footer">
        <div className="report-footer-title">{t(TRANSLATIONS_REPORTS.healthReport.footer.title)}</div>
        <div className="report-footer-description">{t(TRANSLATIONS_REPORTS.healthReport.footer.description)}</div>
      </div>
      <div className="feedback-container only-landing">
        <div className="feedback-buttons">
          <BdsIconButton
            disabled={disabled}
            icon={THUMBS_UP_ICON}
            action={() => onFeedback(THUMBS_UP)}
            size="md"
            variant="secondary-inverse"
            className={`fb-button ${selectedType === THUMBS_UP ? 'selected' : ''}`}
          />
          <BdsIconButton
            disabled={disabled}
            icon={THUMBS_DOWN_ICON}
            action={() => onFeedback(THUMBS_DOWN)}
            size="md"
            variant="secondary-inverse"
            className={`fb-button ${selectedType === THUMBS_DOWN ? 'selected' : ''}`}
          />
        </div>
        <div className="feedback-text">{t(TRANSLATIONS_REPORTS.healthReport.footer.feedback)}</div>
      </div>
    </div>
  );
};

export default HealthReportFooter;
